/**
 * Input Schema of EsconderMotorista
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {EsconderMotorista} from '@/model/resource/EsconderMotorista'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated schema */
export class InputEsconderMotoristaSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputEsconderMotorista'

  readonly fieldSet: FieldSet<EsconderMotorista> = {
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    data: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
